'use strict';

import React, {Component} from "react";
import {observer} from "mobx-react";
import {isArray} from 'underscore';
import Loader from "@uw-it-sis/lib-react/lib/Loader";
import moment from "moment";

import Button from "react-bootstrap/Button";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import ListGroup from "react-bootstrap/ListGroup";

import SliderRange from "@uw-it-sis/lib-react/lib/SliderRange";
import {States, DaysOfWeek} from "@uw-it-sis/lib-react/lib/AppConstants";

import reservedTimeFilterStore from './ReservedTimeFilterStore'
import HelpPopover from "@uw-it-sis/lib-react/lib/HelpPopover";
import appStore from "@uw-it-sis/lib-react/lib/AppStore";

class ReservedTimeFilter extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.store = reservedTimeFilterStore;

        this.state = {
            startEndTimes: [
                this.convertTimeToMinutes(this.store.formData.startTime),
                this.convertTimeToMinutes(this.store.formData.endTime)
            ]
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onAfterChange = this.onAfterChange.bind(this);
    }

    openModal() {
        this.setState({
            startEndTimes: [
                this.convertTimeToMinutes(this.store.formData.startTime),
                this.convertTimeToMinutes(this.store.formData.endTime)
            ]
        });
        this.store.openReserveTimeFilterModal();
    }

    closeModal() {
        this.store.closeReserveTimeFilterModal();
    }

    // Change to reserve time filter form data will either update store or update
    // current component state during slider slide. Slider only saves to store
    // after the sliding is completed.
    onChange(data) {
        if (isArray(data)) {
            this.setState({startEndTimes: data});
        } else {
            let property = data.target.name;
            this.store.updateFormData(property, data.target.checked);
        }
    }

    // After slider sliding completes update store form data
    onAfterChange() {
        this.state.startEndTimes.map((value, index) => {
            let time = this.convertMinutesToTime(value);
            let property;
            switch (index) {
                case 0:
                    property = "startTime";
                    break;
                case 1:
                    property = "endTime";
                    break;
            }

            this.store.updateFormData(property, time);
        });
    }

    // Convert the slider values to 12 hour time format
    convertMinutesToTime(minutes) {
        let tempTime = moment.utc(0).add({hours: 6, minutes: 30});
        let adjustedTime = tempTime.add(minutes, 'minutes');
        return adjustedTime.format("h:mm A");
    }

    // Convert 12 hour time to number of minutes after 6:30 AM for slider values
    convertTimeToMinutes(time) {
        let startTime = moment('6:30 AM', 'h:mm A');
        let untilTime = moment(time, 'h:mm A');
        let diff = untilTime.diff(startTime);

        return moment.duration(diff).asMinutes();
    }

    // Action to add a new reserve time filter
    add = () => {
        this.store.addReservedTimeFilter();
    }

    // Action to update an existing reserve time filter
    update = () => {
        this.store.updateReservedTimeFilter();
    }

    // Action to open modal and set form data to existing reserve time filter
    edit = (filter) => {
        const entries = Object.entries(filter);
        entries.map(filter => this.store.updateFormData(filter[0], filter[1]));
        this.setState({startEndTimes: [
                this.convertTimeToMinutes(filter.startTime),
                this.convertTimeToMinutes(filter.endTime)
            ]});
        this.openModal();
    }

    // Action to delete an existing reserve time filter
    delete = (id) => {
        this.store.deleteReservedTimeFilter(id);
    }

    render() {
        let reservedTimeFilterModal;

        if (this.store.showReservedTimeFilterModal) {
            let daysOfWeekFilters = DaysOfWeek.map((day, index) => {
                return (
                    <Form.Check id={`sb-reserved-time-filter-${day.key}`}
                                name={day.key}
                                type="checkbox"
                                inline
                                label={moment().day(day.key).format("dddd")}
                                checked={this.store.formData[day.key]}
                                aria-checked={this.store.formData[day.key]}
                                onChange={this.onChange}
                                key={index} />
                )
            });

            let isOneDaySelected = DaysOfWeek.some(day => this.store.formData[day.key]);

            let actionButton;
            if (this.store.state === States.pending) {
                // Show button spinning while pending
                actionButton =
                    <Button variant="primary">
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                    </Button>
            } else {
                // Button for add action
                actionButton =
                    <Button variant="primary"
                            disabled={!isOneDaySelected || appStore.isAdviser()}
                            onClick={this.add}>Add</Button>;
                if (this.store.formData.hasOwnProperty("id") && (this.store.formData.id !== null || this.store.formData.id !== '')) {
                    // Button for update action
                    actionButton =
                        <Button variant="primary"
                                disabled={!isOneDaySelected || appStore.isAdviser()}
                                onClick={this.update}>Update</Button>;
                }
            }

            let startTime = this.convertMinutesToTime(this.state.startEndTimes[0]);
            let endTime = this.convertMinutesToTime(this.state.startEndTimes[1]);

            reservedTimeFilterModal =
                <Modal show={this.store.showReservedTimeFilterModal}
                       onHide={this.closeModal}
                       aria-labelledby="reserve-time-filter-modal"
                       centered>
                    <Modal.Header closeButton>
                        <Modal.Title id="reserve-time-filter-modal">Exclude sections that meet on...</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <fieldset>
                            <legend className="sr-only">
                                Days of the week
                            </legend>
                            {daysOfWeekFilters}
                        </fieldset>
                        <div className="slider-container">
                            <div className="slider-label" aria-live="polite" aria-atomic="true">
                                <span className="sr-only">Exclude times between:</span>
                                <time dateTime={moment(startTime, "h:mm A").format("HH:mm")}>{startTime}</time>
                                <span className="sr-only"> and </span>
                                <span aria-hidden={true}> &mdash; </span>
                                <time dateTime={moment(endTime, "h:mm A").format("HH:mm")}>{endTime}</time>
                            </div>
                            <div className="slider-component">
                                <SliderRange
                                    min={0}
                                    max={960}
                                    step={30}
                                    allowCross={false}
                                    pushable={30}
                                    value={this.state.startEndTimes}
                                    onChange={this.onChange}
                                    onAfterChange={this.onAfterChange}
                                    handleFormatter={this.convertMinutesToTime}
                                />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        {actionButton}
                        <Button variant="secondary" disabled={this.store.state === States.pending} onClick={this.closeModal}>Cancel</Button>
                    </Modal.Footer>
                </Modal>;
        }

        const reservedTimeFilters = this.store.getReservedTimeFilters();
        let reserveTimeFiltersList;

        if (reservedTimeFilters.length > 0) {
            let reserveTimeFiltersListItems = reservedTimeFilters.map((filter, i) => {
                let filterDays = DaysOfWeek.filter(day => filter[day.key]).map(day => {
                    return day.shortCode;
                });

                return (
                    <ListGroup.Item as="li" key={i} className="d-flex align-items-center py-1 px-2">
                        <div>
                            <span className="me-4">{filterDays.join("")}</span>
                            <time dateTime={moment(filter.startTime, "h:mm A").format("HH:mm")}>{filter.startTime}</time>
                            <span> - </span>
                            <time dateTime={moment(filter.endTime, "h:mm A").format("HH:mm")}>{filter.endTime}</time>
                        </div>
                        <ButtonToolbar className="ms-auto keep-horizontal">
                            <Button variant="inline-link" size="sm" onClick={() => this.edit(filter)} disabled={appStore.isAdviser()}>Edit</Button>
                            <Button variant="inline-link" size="sm" onClick={() => this.delete(filter.id)} disabled={appStore.isAdviser()}>Delete</Button>
                        </ButtonToolbar>
                    </ListGroup.Item>
                );
            });

            reserveTimeFiltersList = <ListGroup as="ul" className="mb-3">{reserveTimeFiltersListItems}</ListGroup>;
        }

        let addReservedTimeFilters;
        if (reservedTimeFilters.length <= 10) {
            addReservedTimeFilters = <Button variant="inline-link" onClick={this.openModal} disabled={appStore.isAdviser()}>&#43; Add days/times</Button>;
        }

        const loaderSpinner = <Spinner
            as="span"
            size="sm"
            animation="border"
            role="status"
            aria-hidden="true"
        />;

        let excludeHelp =
            <HelpPopover title="Excluded Sections" className="ms-2" placement="top">
                Schedule Builder will exclude the sections that meet on the days and times you've blocked from the calendar.
            </HelpPopover>;
        return (
            <>
                <div className="d-flex align-items-center mb-3"><strong>Exclude sections that meet on...</strong>{excludeHelp}</div>
                <Loader show={this.store.state === States.pending} message={loaderSpinner} contentBlur={1} disableDefaultStyles>
                    {reserveTimeFiltersList}
                    {addReservedTimeFilters}
                    {reservedTimeFilterModal}
                </Loader>
            </>
        );
    }
}

export default observer(ReservedTimeFilter);